import { getFixedValue, convert } from "./currencyConvertion";

export const getServiceFeeValue = ({ serviceFees, totalWithoutServiceFee, base, rates, currency }) => {
    try {
        let guestServiceFee = 0, hostServiceFee = 0;

        if (serviceFees?.guest) {
            guestServiceFee = serviceFees.guest.type === 'percentage'
                ? totalWithoutServiceFee * (Number(serviceFees.guest.value) / 100)
                : convert(base, rates, serviceFees.guest.value, serviceFees.guest.currency, currency);
                guestServiceFee = getFixedValue(guestServiceFee);
        }

        if (serviceFees?.host) {
            hostServiceFee = serviceFees.host.type === 'percentage'
                ? totalWithoutServiceFee * (Number(serviceFees.host.value) / 100)
                : getFixedValue(convert(base, rates, serviceFees.host.value, serviceFees.host.currency, currency));
        }

        return { guestServiceFee, hostServiceFee };
    } catch (error) {
        return { guestServiceFee: 0, hostServiceFee: 0 };
    }
};